// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__jnaXl","avatarImg":"Avatar_avatarImg__LykuQ","setting":"Avatar_setting__pdynb"};